var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialInstagram = function SvgSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".social-instagram_svg__st0,.social-instagram_svg__st1{fill:#231f20}.social-instagram_svg__st1,.social-instagram_svg__st2{fill-rule:evenodd;clip-rule:evenodd}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social-instagram_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.8 76.9H31c-5.6 0-10.1-4.5-10.1-10.1V31c0-5.6 4.5-10.1 10.1-10.1h35.8c5.6 0 10.1 4.5 10.1 10.1v35.8c0 5.6-4.5 10.1-10.1 10.1zM48.9 40c-4.9 0-9 4-9 9s4 9 9 9 9-4 9-9-4.1-9-9-9zm21.3-12.4h-9v9h9v-9zm1.1 15.7h-7.7c.7 1.8 1 3.6 1 5.6 0 8.6-7.1 15.7-15.7 15.7s-15.7-7.1-15.7-15.7c0-2 .3-3.8 1-5.6h-7.7v20.2c0 4.4 3.5 7.8 7.8 7.8h29.1c4.4 0 7.8-3.5 7.8-7.8V43.3z",
    id: "social-instagram_svg__instegram"
  }))));
};
export default SvgSocialInstagram;